<style src="./TariffSchedule.scss" lang="scss"></style>
<template>
  <div class="TariffSchedule wrapper wrapper-content animated fadeIn">
    <div class="row">
      <div class="col-lg-5">
        <div class="ibox float-e-margins">
          <div class="ibox-content mailbox-content">
            <form v-on:submit.prevent="createSchedule">
              <h2>Cadastro de Agenda</h2>
              <div class="space-25"></div>

              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="Lado B"
                  class="form-control"
                  v-model="registerForm.form.name"
                />
              </div>
              <h3>Plano</h3>
              <div>
                <table class="table table-hover table-mail">
                  <thead class="table-head">
                    <tr>
                      <th>Inicio</th>
                      <th>Termino</th>
                      <th>Plano</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody class="table-list ">
                    <tr
                      v-for="(plan, listIdx) in registerForm.form.plans"
                      :key="listIdx"
                    >
                      <td>
                        <p class="calendar date">
                          {{ plan.startDate | formatDate }}
                        </p>
                        <p class="calendar time">
                          {{ plan.startDate | formatTime }}
                        </p>
                      </td>
                      <td>
                        <p class="calendar date">
                          {{ plan.endDate | formatDate }}
                        </p>
                        <p class="calendar time">
                          {{ plan.endDate | formatTime }}
                        </p>
                      </td>
                      <td>{{ plan.tariffPlan.name }}</td>
                      <td class="list-command">
                        <button
                          type="button"
                          class="btn btn-outline"
                          @click="editPlanMode(plan, listIdx)"
                        >
                          <i class="fa fa-edit text-success"></i>
                        </button>
                      </td>
                      <td>
                        <button
                          type="button"
                          class="btn btn-outline"
                          title="Remover"
                          @click="removePlan(listIdx)"
                        >
                          <i class="fa fa-trash text-danger"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <form v-on:submit.prevent="addPlan">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label>Inicio</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        min="initialDateLimit"
                        v-model="startDateFormatted"
                      />
                    </div>
                    <div class="form-group col-lg-6">
                      <label>Termino</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        v-model="endDateFormatted"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Plano tarifário</label>
                    <select class="form-control" v-model="planForm.tariffPlan">
                      <option
                        v-for="(item, idx) in plansList"
                        :key="idx"
                        :value="{ _id: item._id, name: item.name }"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <button
                    class="btn btn-block btn-primary compose-mail"
                    href="mail_compose.html"
                    v-if="!planForm.editPlan"
                  >
                    <i class="fa fa-save"></i>
                    Adicionar Plano
                  </button>
                  <div v-if="planForm.editPlan">
                    <button
                      type="button"
                      class="btn btn-outline"
                      href="mail_compose.html"
                      @click="exitEditPlan()"
                    >
                      Cancelar
                    </button>

                    <button
                      type="button"
                      class="btn btn-warning pull-right"
                      href="mail_compose.html"
                      @click="savePlan()"
                    >
                      <i class="fa fa-save"></i>
                      Salvar
                    </button>
                  </div>
                </form>
              </div>
              <br /><br />
              <button
                class="btn btn-block btn-primary compose-mail"
                href="mail_compose.html"
                :disabled="
                  !permissionCreate ||
                    registerForm.control.createButtonIsDisabled
                "
                v-if="!registerForm.control.editModeId"
              >
                <i class="fa fa-save"></i>
                Criar Agenda
              </button>

              <div v-if="registerForm.control.editModeId">
                <button
                  type="button"
                  class="btn btn-outline"
                  href="mail_compose.html"
                  :disabled="registerForm.control.createButtonIsDisabled"
                  @click="disableEditMode"
                >
                  Cancelar
                </button>

                <button
                  type="button"
                  class="btn btn-warning pull-right"
                  href="mail_compose.html"
                  :disabled="
                    registerForm.control.createButtonIsDisabled ||
                      !permissionUpdate
                  "
                  @click="saveEdition"
                >
                  <i class="fa fa-save"></i>
                  Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-7 animated fadeInRight" v-if="permissionRead">
        <div class="mail-box-header">
          <h2>Lista de Agendas</h2>
          <table class="table table-hover table-mail">
            <thead class="table-head">
              <tr>
                <th>Nome</th>

                <th></th>
                <th></th>
              </tr>
            </thead>

            <tbody class="table-list">
              <tr v-for="(listItem, listIdx) in scheduleList" :key="listIdx">
                <td>{{ listItem.name }}</td>

                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="enterEditMode(listItem)"
                    v-if="permissionUpdate"
                  >
                    <i class="fa fa-edit text-success"></i>
                  </button>
                </td>
                <td class="list-command">
                  <button
                    class="btn btn-outline"
                    @click="deleteSchedule(listItem)"
                    v-if="permissionDelete"
                  >
                    <i class="fa fa-trash text-danger"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';

export default {
  name: 'RegisterZones',

  data() {
    return {
      registerForm: {
        form: {
          name: '',
          plans: [],
        },
        control: {
          editModeId: false,
          createButtonIsDisabled: false,
        },
      },
      planForm: {
        index: false,
        editPlan: false,
        startDate: new Date(),
        endDate: new Date(),
        tariffPlan: {},
      },
      searchForm: {
        form: {
          name: '',
        },
        control: {},
      },
      plansList: [],
      scheduleList: [],
      initialDateLimit: format(new Date(), "yyyy-MM-dd'T'HH:mm"),
    };
  },
  computed: {
    permissionCreate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-schedule',
        'CREATE',
      );
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-schedule',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-schedule',
        'UPDATE',
      );
    },
    permissionDelete() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'tariff-schedule',
        'DELETE',
      );
    },
    endDateFormatted: {
      get() {
        return format(new Date(this.planForm.endDate), "yyyy-MM-dd'T'HH:mm");
      },
      set(date) {
        this.planForm.endDate = new Date(date);
      },
    },
    startDateFormatted: {
      get() {
        return format(new Date(this.planForm.startDate), "yyyy-MM-dd'T'HH:mm");
      },
      set(date) {
        this.planForm.startDate = new Date(date);
      },
    },
  },

  mounted() {
    this.listPlans();
    this.listShedules();
  },
  filters: {
    formatDate(value) {
      const date = new Intl.DateTimeFormat('pt-BR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(value));

      return date;
    },
    formatTime(value) {
      const time = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));

      return time;
    },
  },
  methods: {
    async listPlans() {
      if (!this.permissionRead) {
        return;
      }
      const plansList = await this.$store.dispatch('TARIFF-PLAN/LoadPlans');
      this.plansList = plansList;
      this.planForm.tariffPlan = {
        _id: plansList[0]._id,
        name: plansList[0].name,
      };
    },
    formatDate(date) {
      return new Date(date);
    },
    // plan
    addPlan() {
      const payload = {
        tariffPlan: this.planForm.tariffPlan,
        startDate: this.planForm.startDate,
        endDate: this.planForm.endDate,
      };
      this.registerForm.form.plans.push(payload);
      this.planForm.startDate = this.initialDateLimit;
      this.planForm.endDate = this.initialDateLimit;
    },
    removePlan(index) {
      const plans = this.registerForm.form.plans;
      plans.splice(index, 1);
      this.registerForm.form.plans = plans;
    },
    editPlanMode(plan, index) {
      this.planForm.editPlan = true;
      this.planForm.index = index;
      this.planForm.startDate = this.formatDate(plan.startDate);
      this.planForm.endDate = this.formatDate(plan.endDate);

      this.planForm.tariffPlan = {
        _id: plan.tariffPlan._id,
        name: plan.tariffPlan.name,
      };
    },
    exitEditPlan() {
      this.planForm.editPlan = false;
      this.planForm.index = false;
      this.planForm.startDate = this.formatDate(new Date());
      this.planForm.endDate = this.formatDate(new Date());

      this.planForm.tariffPlan = {
        _id: this.plansList[0]._id,
        name: this.plansList[0].name,
      };
    },
    savePlan() {
      const planPayload = {
        tariffPlan: this.planForm.tariffPlan,
        startDate: this.planForm.startDate,
        endDate: this.planForm.endDate,
      };
      const plans = this.registerForm.form.plans;
      const index = this.planForm.index;

      plans[index] = planPayload;
      this.registerForm.form.plans = plans;
      this.exitEditPlan();
    },
    // schedule
    formatePlans() {
      return this.registerForm.form.plans.map(plan => {
        return {
          ...plan,
          tariffPlan: plan.tariffPlan._id,
        };
      });
    },
    async createSchedule() {
      if (!this.permissionCreate) {
        return;
      }
      if (
        this.registerForm.form.name.length === 0 ||
        this.registerForm.form.plans.length === 0
      ) {
        return;
      }
      this.registerForm.control.createButtonIsDisabled = true;

      const payload = {
        ...this.registerForm.form,
        plans: this.formatePlans(),
      };

      try {
        await this.$store.dispatch(
          'TARIFF-SCHEDULE/CreateTariffSchedule',
          payload,
        );
        this.listShedules();

        this.registerForm.form.name = '';
        this.registerForm.form.plans = [];

        this.$toasted.success('Agenda castrada com sucesso');
      } catch (error) {
        this.$toasted.error('Não foi possível criar a agenda');
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
    async listShedules() {
      try {
        const schdules = await this.$store.dispatch(
          'TARIFF-SCHEDULE/LoadTariffSchedules',
        );
        this.scheduleList = schdules;
      } catch (error) {
        this.$toasted.error('Não foi possivél listar as agendas');
      }
    },
    enterEditMode(schedule) {
      this.registerForm.control.editModeId = schedule._id;
      this.registerForm.form.name = schedule.name;
      this.registerForm.form.plans = schedule.plans;
    },
    disableEditMode() {
      this.registerForm.control.editModeId = false;
      this.registerForm.form.name = '';
      this.registerForm.form.plans = [];
    },
    async deleteSchedule({ name, _id }) {
      if (
        confirm(`Deseja deletar o plano ${name}? Essa operação não tem volta.`)
      ) {
        try {
          const id = _id;
          await this.$store.dispatch('TARIFF-SCHEDULE/RemoveTariffSchedule', {
            id,
          });
          this.listShedules();
          this.$toasted.success('Plano removido com sucesso');
        } catch (error) {
          this.$toasted.error(error.error);
        }
      }
    },
    async saveEdition() {
      if (
        this.registerForm.form.name.length === 0 ||
        this.registerForm.form.plans.length === 0
      ) {
        return;
      }
      this.registerForm.control.createButtonIsDisabled = true;

      const id = this.registerForm.control.editModeId;
      const payload = {
        ...this.registerForm.form,
        plans: this.formatePlans(),
      };

      try {
        await this.$store.dispatch('TARIFF-SCHEDULE/UpdateTariffSchedule', {
          id,
          payload,
        });
        this.listShedules();

        this.disableEditMode();
        this.$toasted.success('Agenda salva com sucesso');
      } catch (error) {
        this.$toasted.error(error.error);
      } finally {
        this.registerForm.control.createButtonIsDisabled = false;
      }
    },
  },
};
</script>
